import { render, staticRenderFns } from "./CashCategoriesManager.vue?vue&type=template&id=3919036a&scoped=true&"
import script from "./CashCategoriesManager.vue?vue&type=script&lang=js&"
export * from "./CashCategoriesManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3919036a",
  null
  
)

export default component.exports